"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createEditorContent", {
  enumerable: true,
  get: function () {
    return _createEditorContent.default;
  }
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _immutable = require("immutable");
var _draftJs = require("draft-js");
var _Toolbar = _interopRequireWildcard(require("./Toolbar"));
var _createEditorContent = _interopRequireDefault(require("./create-editor-content"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // Current module dependencies
if (require('exenv').canUseDOM) require('./styles.scss');
class RebooEditor extends _react.Component {
  constructor(props) {
    super(props);
    let editorState = _draftJs.EditorState.createEmpty(_Toolbar.decorator);
    if (this.props.value) {
      let contentState;
      if (typeof this.props.value === 'string') {
        // initialValue is a string with syntax HTML, we need transform in contentState
        contentState = _draftJs.ContentState.createFromBlockArray((0, _draftJs.convertFromHTML)(this.props.value));
      } else if (typeof this.props.value === 'object') {
        contentState = (0, _draftJs.convertFromRaw)(this.props.value);
      } else {
        throw new Error('Value invalid');
      }
      editorState = _draftJs.EditorState.createWithContent(contentState, _Toolbar.decorator);
    }
    this.state = {
      editorState,
      hasFocus: false
    };
  }
  focus() {
    this.setState({
      hasFocus: true
    }, () => setTimeout(() => this.refs.editor.focus()));
  }
  onChangeEditorState(editorState) {
    this.setState({
      editorState
    });
  }
  handleKeyCommand(command) {
    const editorState = this.state.editorState;
    const currentBlock = editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey());
    // Modify behavior to insert new line
    if (command === 'split-block' && currentBlock.getType() === 'atomic') {
      // Create a contentBlock done to be insert
      const contentBlock = new _draftJs.ContentBlock({
        key: (0, _draftJs.genKey)(),
        type: 'unstyled'
      });
      const contentBlockMap = new _immutable.OrderedMap([[contentBlock.getKey(), contentBlock]]);
      const currentContent = editorState.getCurrentContent();
      const currentBlockMap = currentContent.getBlockMap();

      // split blocks with current block
      const skipCurrent = block => block === currentBlock;
      const beforeBlocks = currentBlockMap.toSeq().takeUntil(skipCurrent);
      const afterBlocks = currentBlockMap.toSeq().skipUntil(skipCurrent).rest();
      let blockMap;
      if (editorState.getSelection().getAnchorOffset() < editorState.getSelection().getFocusOffset()) {
        // mount block map with new block to insert in place of old block
        blockMap = beforeBlocks.concat(contentBlockMap.toSeq(), afterBlocks).toOrderedMap();
      } else {
        // mount block map with new block to insert before
        blockMap = beforeBlocks.concat(new _immutable.OrderedMap([[currentBlock.getKey(), currentBlock]]).toSeq(), contentBlockMap.toSeq(), afterBlocks).toOrderedMap();
      }
      const content = currentContent.merge({
        blockMap
      });
      const editorStateWithLineBreak = _draftJs.EditorState.push(editorState, content, 'insert-new-line');
      this.onChangeEditorState(_draftJs.EditorState.forceSelection(editorStateWithLineBreak, editorStateWithLineBreak.getSelection().merge({
        anchorKey: contentBlock.getKey(),
        anchorOffset: 0,
        isBackward: false
      })));
      return true;
    }
    return false;
  }
  blockStyleFn(block) {
    // TODO: Move to control and receive like plugin
    const editorState = this.state.editorState;
    let alignment = (0, _Toolbar.getBlockAlignment)(block);
    if (!block.getText()) {
      let previousBlock = editorState.getCurrentContent().getBlockBefore(block.getKey());
      if (previousBlock) {
        alignment = (0, _Toolbar.getBlockAlignment)(previousBlock);
      }
    }
    return "alignment--".concat(alignment);
  }
  handleBeforeInput(chars) {
    const editorState = this.state.editorState;
    const selection = editorState.getSelection();
    const block = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
    if (chars === ' ' && block.getType() === 'atomic') {
      this.handleKeyCommand('split-block');
      return true;
    }
    return false;
  }
  save() {
    this.props.handleSave((0, _draftJs.convertToRaw)(this.state.editorState.getCurrentContent()));
    this.setState({
      hasFocus: false
    });
  }
  render() {
    // Injected root container props
    const containerStyle = this.props.containerStyle; // Injected Toolbar props
    const _this$props = this.props,
      toolbarStyle = _this$props.toolbarStyle,
      toolbarContainerStyle = _this$props.toolbarContainerStyle,
      theme = _this$props.theme; // Injected Editor props
    const _this$props2 = this.props,
      editorStyle = _this$props2.editorStyle,
      focusStyle = _this$props2.focusStyle,
      readOnly = _this$props2.readOnly;
    const hasFocusStyle = this.state.hasFocus && !readOnly ? focusStyle || {
      outline: '1px solid blue'
    } : {};
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "reboo-editor",
      style: containerStyle
    }, !readOnly ? /*#__PURE__*/_react.default.createElement("div", {
      className: "toolbar-container",
      style: _objectSpread(_objectSpread({}, toolbarContainerStyle), {}, {
        display: this.state.hasFocus ? 'block' : 'none'
      })
    }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
      theme: theme,
      buttonClassName: "btn white p2",
      popoverClassName: "absolute white p2 bg-darken-4 rounded-bottom",
      editorState: this.state.editorState,
      setEditorState: this.onChangeEditorState.bind(this),
      focusEditor: this.focus.bind(this),
      style: toolbarStyle
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "outside",
      onClick: this.save.bind(this)
    })) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: "editor",
      style: _objectSpread(_objectSpread({}, editorStyle), hasFocusStyle)
    }, /*#__PURE__*/_react.default.createElement("div", {
      onClick: this.focus.bind(this)
    }, /*#__PURE__*/_react.default.createElement(_draftJs.Editor, (0, _extends2.default)({
      readOnly: readOnly,
      editorState: this.state.editorState,
      onChange: this.onChangeEditorState.bind(this),
      blockStyleFn: this.blockStyleFn.bind(this),
      handleKeyCommand: this.handleKeyCommand.bind(this),
      handleBeforeInput: this.handleBeforeInput.bind(this)
    }, _Toolbar.toolbarEditorProps)), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        'clear': 'both'
      }
    })), !readOnly ? /*#__PURE__*/_react.default.createElement("div", {
      className: "right mt1",
      style: {
        display: this.state.hasFocus ? 'block' : 'none',
        width: '100%',
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "btn caps bg-darken-4 white rounded",
      onClick: this.save.bind(this)
    }, "Salvar"), /*#__PURE__*/_react.default.createElement("button", {
      className: "btn bg-darken-4 white rounded",
      style: {
        position: 'absolute',
        right: '0'
      },
      onClick: this.props.handleDelete
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-trash"
    }))) : null));
  }
}
RebooEditor.defaultProps = {
  readOnly: false
};
var _default = exports.default = RebooEditor;